module.exports = __webpack_public_path__ + "img/Dashboard.5d611b40.svg";